import { MARQUEE } from "@/content/site";

const Row = ({ hidden }) => (
  <div className="flex shrink-0 items-center" aria-hidden={hidden}>
    {MARQUEE.map((t, i) => (
      <span key={t} className="flex items-center font-display font-black uppercase text-5xl md:text-7xl whitespace-nowrap">
        <span className={i % 2 ? "stroke-text" : "text-white"}>{t}</span>
        <span className="mx-8 md:mx-12 inline-block h-3 w-3 rotate-45 bg-[var(--red)]" />
      </span>
    ))}
  </div>
);

export default function Marquee() {
  return (
    <section className="py-10 md:py-14 border-b border-[var(--line)] overflow-hidden metal" aria-label="What we work on" data-testid="marquee">
      <div className="marquee-track flex w-max">
        <Row />
        <Row hidden />
      </div>
    </section>
  );
}
